import { useSubscriptionContext } from "lib/contexts/SubscriptionProvider";
export const useIsSubscribeMode = (): boolean => {
  const {
    state: { mode },
  } = useSubscriptionContext();

  return mode === "SUBSCRIBE";
};
